import axios from "axios";

export const getTokenSensedia = async (tokenCognito) => {
  try {
    const resultadoGetToken = await axios.post(
      "https://api.direcional.com.br/oauth/access-token",
      {
        grant_type: "client_credentials",
        extraInfo: {
          "token-cognito": `Bearer ${tokenCognito}`,
        },
      },
      {
        headers: {
          Authorization: `Basic Y2RmNDRhMzAtMzJhNC0zOTMwLTllODItNGVlOGE4YTdkOGYwOmU0ZWE1YmNmLWM3ZDEtMzVhYy1hZGJhLTBhM2U4ODA4OWNmNw==`,
        },
      }
    );
    return resultadoGetToken;
  } catch (error) {
    return "unable_to_generate_sensedia_code";
  }
};
